/* Review cards are a fixed height; longer bodies get a see-more toggle.
   Reviews.io renders async and swaps the list on pagination, so watch for it. */
(function () {
  // must be scoped to .item__inner — .item__meta carries a .u-marginBottom--md too,
  // whose .R-TextBody child is the author location, and it comes first in the DOM
  function bodyOf(card) {
    return card.querySelector('.item__inner .u-marginBottom--md > .R-TextBody');
  }

  function sync(card, more, less) {
    var body = bodyOf(card);
    if (!body) return;

    var btn = card.querySelector('.sh-reviews__more');
    // when expanded the body no longer overflows, so keep the button on that basis
    var needs = card.classList.contains('is-expanded') ||
      body.scrollHeight > body.clientHeight + 1;

    if (!needs) {
      if (btn) btn.remove();
      return;
    }
    if (btn) return;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sh-reviews__more';
    btn.textContent = more;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = card.classList.toggle('is-expanded');
      btn.textContent = open ? less : more;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // anchor to the date's own row rather than :last-child, which shifts
    // when a review carries helpful votes
    var date = card.querySelector('.c-reviewDateTime');
    var row = (date && date.parentElement) || card.querySelector('.item__inner') || card;
    row.insertBefore(btn, row.firstChild);
  }

  function clearLoading(root) {
    if (!root.classList.contains('sh-reviews--loading')) return;
    root.classList.remove('sh-reviews--loading');
    var sk = root.querySelector('.sh-reviews__skeleton');
    if (sk) sk.remove();
  }

  function init(root) {
    var more = root.dataset.moreLabel || 'Mehr anzeigen';
    var less = root.dataset.lessLabel || 'Weniger anzeigen';
    var queued = false;

    function scan() {
      queued = false;
      var cards = root.querySelectorAll('.R-ContentList__item');
      if (cards.length) clearLoading(root);
      cards.forEach(function (card) {
        sync(card, more, less);
      });
    }

    // products with no reviews never render a card — don't strand the widget
    setTimeout(function () { clearLoading(root); }, 8000);

    // our own insert retriggers the observer, so coalesce to one pass per frame
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(scan);
    }

    scan();
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
  }

  function boot() {
    document.querySelectorAll('[data-sh-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sh-reviews]');
    if (root) init(root);
  });
})();
